import * as React from 'react';
import { Button, Collapse } from 'antd';
import { Field, getFormValues, InjectedFormProps, reduxForm } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { offerSlice } from 'logic/store/offer/offer.slice';
import { MapBoxPlace } from 'logic/store/geolocation/geolocation.model';
import { translate, translationKeys } from '../../../logic/translations/translations.service';
import {
  SEARCH_FORM_NAME,
  SearchFormValues,
  validateSearchForm,
  SearchFormFields,
} from '../search.logic';
import { FormSubjectNameSelectInput } from '../../form-inputs/form-subject-name-select-input/form-subject-name-select-input';
import { TutoringKind } from '../search.const';
import './results-search.styles.less';
import { FormLocationSearchInput } from 'components/form-inputs/form-location-search-input/form-location-search-input';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { TeachingLevelInput } from 'components/teaching-inputs';
const { Panel } = Collapse;

const ResultsSearch: React.FC<InjectedFormProps> = () => {
  const dispatch = useDispatch();
  const formValues: SearchFormValues = useSelector(getFormValues(SEARCH_FORM_NAME)) || {};
  const { kind } = formValues;
  const { maxSmallMobile, minTablet } = useBreakpoints();

  const handleSearch = () =>
    dispatch(
      offerSlice.actions.navigateToSearchResults({
        formValues: { ...formValues, page: undefined },
      })
    );

  const shouldHideCity = kind === TutoringKind.onlineTutoring;

  const renderSearch = () => {
    return (
      <div className="results-search-container noselect">
        <div className="search-inputs">
          {!shouldHideCity && (
            <Field
              name={SearchFormFields.city}
              component={FormLocationSearchInput}
              formItemClassName="search-input city"
              placeholder={translate(translationKeys.search.fields.where)}
              valuePlace={MapBoxPlace.City}
              searchPlaces={[MapBoxPlace.City, MapBoxPlace.Postcode]}
            />
          )}
          <Field
            name={SearchFormFields.subjectName}
            formItemClassName="search-input subject"
            component={FormSubjectNameSelectInput}
            placeholder={
              maxSmallMobile
                ? translate(translationKeys.search.fields.inWhichSubjectDoYouNeedHelpShort)
                : translate(translationKeys.search.fields.inWhichSubjectDoYouNeedHelp)
            }
          />
          <div style={{ minWidth: '150px' }} className="search-input teachingLevel">
            <TeachingLevelInput
              label={''}
              showLabel={false}
              levelsVariant={'requestTeachingLevel'}
              fieldName={SearchFormFields.requestTeachingLevel}
              style={{ marginTop: 0 }}
            />
          </div>
          <Button
            type="primary"
            size="large"
            className="search-input search-button"
            onClick={handleSearch}
          >
            {translate(translationKeys.buttons.search)}
          </Button>
        </div>
      </div>
    );
  };

  if (minTablet) return renderSearch();

  return (
    <div style={{ margin: 12 }}>
      <Collapse style={{ margin: 0, padding: 0 }} accordion>
        <Panel header={translate(translationKeys.search.fields.collapseText)} key="1">
          {renderSearch()}
        </Panel>
      </Collapse>
    </div>
  );
};

export const ResultsSearchForm = reduxForm({
  form: SEARCH_FORM_NAME,
  validate: validateSearchForm,
  destroyOnUnmount: false,
})(ResultsSearch);
